import { render, staticRenderFns } from "./warn-line-dialog.vue?vue&type=template&id=2b99d0d3&scoped=true&"
import script from "./warn-line-dialog.vue?vue&type=script&lang=js&"
export * from "./warn-line-dialog.vue?vue&type=script&lang=js&"
import style0 from "./warn-line-dialog.vue?vue&type=style&index=0&id=2b99d0d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99d0d3",
  null
  
)

export default component.exports